import Axios from "axios";
import Vue from "vue";
import i18n from "../../i18n";

import { API_HOST } from "../../config/app-const";
import { makePublicInsightApiRequest } from "../../helpers/request";
import { pagination } from "../../helpers/store";
import { getUrlParams } from '../../helpers/pagination';

const state = {
    organizations: {
        isBusy: true,
        data: {
            data: [],
            pagination: { ...pagination, currentPage: pagination?.page || 0 }
        },
        error: null
    },
    all_organizations: {
        isBusy: false,
        data: null,
        error: null
    }
};

const mutations = {
    LOAD_ORGANIZATIONS_BUSY: function(state, payload) {
        state.organizations.isBusy = payload;
    },
    LOAD_ORGANIZATIONS_SUCCESS: function(state, payload) {
        let currentData = payload.data?.pagination?.currentPage > 1 ? state.organizations?.data?.data : []
        let payloadData = { data: [...currentData || [], ...payload?.data?.data || []], pagination: payload.data.pagination };    
        state.organizations.data = payloadData;
        state.organizations.error = null;
    },
    LOAD_ORGANIZATIONS_FAIL: function(state, payload) {
        state.organizations.error = payload;
        state.organizations.data = null;
    },
    CREATE_ORGANIZATION_BUSY: function() {},
    CREATE_ORGANIZATION_SUCCESS: function(state, payload) {
        state.organizations.data?.data?.unshift(payload);
        state.organizations.error = null;
    },
    CREATE_ORGANIZATION_FAIL: function(state, payload) {
        state.organizations.error = payload;
    },
    UPDATE_ORGANIZATION_BUSY: function() {},
    UPDATE_ORGANIZATION_SUCCESS: function(state, payload) {
        for (let i = 0, l = state.organizations.data?.data?.length; i < l; ++i) {
            if (state.organizations.data?.data?.[i]?.id == payload.id) {
                state.organizations.data.data[i].name = payload.name;
            }
        }
        state.organizations.error = null;
    },
    UPDATE_ORGANIZATION_FAIL: function(state, payload) {
        state.organizations.error = payload;
    },
    DELETE_ORGANIZATION_BUSY: function() {},
    DELETE_ORGANIZATION_SUCCESS: function(state, payload) {
        state.organizations.data.data = state.organizations.data?.data?.filter(item => {
            return item.id !== payload[0].id;
        });
        
        state.organizations.error = null;
    },
    DELETE_ORGANIZATION_FAIL: function(state, payload) {
        state.organizations.error = payload;
    },
    LOAD_ALL_ORGANIZATIONS_SUCCESS: function(state, payload) {
        state.all_organizations.data = payload;
        state.all_organizations.error = null;
    },
    LOAD_ALL_ORGANIZATIONS_FAIL: function(state, payload) {
        state.all_organizations.error = payload;
        state.all_organizations.data = null;
    },
    LOAD_ALL_ORGANIZATIONS_BUSY: function(state, payload) {
        state.all_organizations.isBusy = payload;
    }
};

const actions = {
    getAllOrganizations: ({ commit }, { organizationName }) => {
        commit("LOAD_ALL_ORGANIZATIONS_BUSY", true);
        let query = "search_in[]=organizations&per_page=100";
        if (organizationName) {
            query += `&search=${organizationName}`;
        }

        return makePublicInsightApiRequest({url: `/v4/whatsapp/contact_lists/organizations?${query}`, method: "GET"})
            .then(response => {
                commit("LOAD_ALL_ORGANIZATIONS_SUCCESS", response.data.data.data);
            })
            .catch(function(error) {
                Vue.notify({
                    group: "store_notifications",
                    type: "error",
                    text: i18n.t("messages.request.error")
                });
                commit("LOAD_ALL_ORGANIZATIONS_FAIL", error);
            })
            .finally(() => commit("LOAD_ALL_ORGANIZATIONS_BUSY", false));
    },

    loadOrganizations: function({ commit, rootState }, { projectId, pagination }) {
        commit("LOAD_ORGANIZATIONS_BUSY", true);

        const { accessToken } = rootState.user.user.data;
        const config = {
            headers: { Authorization: `Token token=${accessToken}` }
        };

        let query = getUrlParams(pagination);

        return Axios.get(`${API_HOST}/analysis/${projectId}/organizations?${query}`, config)
            .then(function(response) {
                commit("LOAD_ORGANIZATIONS_SUCCESS", response.data);
            })
            .catch(function(error) {
                Vue.notify({
                    group: "store_notifications",
                    type: "error",
                    text: i18n.t("messages.request.error")
                });

                console.error(error);
                commit("LOAD_ORGANIZATIONS_FAIL", error);
            })
            .finally(function() {
                commit("LOAD_ORGANIZATIONS_BUSY", false)
            });
    },
    createOrganization: function({ commit, rootState }, { projectId, organization }) {
        commit("CREATE_ORGANIZATION_BUSY", true);

        const body = {
            name: organization.name,
            parent_tag_id: organization.parent_tag_id,
            child_tags: organization.child_tags
        };

        const { accessToken } = rootState.user.user.data;
        const config = {
            headers: { Authorization: `Token token=${accessToken}` }
        };

        return Axios.post(`${API_HOST}/analysis/${projectId}/organizations`, body, config)
            .then(function(response) {
                if (!response.data.error) {
                    commit("CREATE_ORGANIZATION_SUCCESS", { ...response.data, parent_tag_id: body?.parent_tag_id });
                    Vue.notify({
                        group: "store_notifications",
                        type: "success",
                        text: i18n.t("messages.tags.organiation.added_successfully")
                    });
                }else{
                    Vue.notify({
                        group: "store_notifications",
                        type: "error",
                        text: response.data.error === "duplicated" ? i18n.t(`tag.form.errors.organization.${response.data.error}`) : i18n.t("messages.request.error")
                    });
                }
            })
            .catch(function(error) {
                console.error(error);
                commit("CREATE_ORGANIZATION_FAIL", error);
            })
            .finally(function() {
                commit("CREATE_ORGANIZATION_BUSY", false);
            });
    },
    updateOrganization: function({ commit, rootState }, { projectId, organization }) {
        commit("UPDATE_ORGANIZATION_BUSY", true);

        const body = {
            name: organization.name,
            parent_tag_id: organization.parent_tag_id
        };

        const { accessToken } = rootState.user.user.data;
        const config = {
            headers: { Authorization: `Token token=${accessToken}` }
        };

        return Axios.put(`${API_HOST}/analysis/${projectId}/organizations/${organization.id}`, body, config)
            .then(function(response) {
                if (!response.data.error) {
                    commit("UPDATE_ORGANIZATION_SUCCESS", { ...response.data, parent_tag_id: body?.parent_tag_id });
                }else{
                    Vue.notify({
                        group: "store_notifications",
                        type: "error",
                        text: i18n.t(`tag.form.errors.organization.${response.data.error}`)
                    });
                }
            })
            .catch(function(error) {
                Vue.notify({
                    group: "store_notifications",
                    type: "error",
                    text: i18n.t("messages.request.error")
                });

                console.error(error);
                commit("UPDATE_ORGANIZATION_FAIL", error);
            })
            .finally(function() {
                commit("UPDATE_ORGANIZATION_BUSY", false);
            });
    },
    deleteOrganization: function({ commit, rootState }, { organizationId, projectId }) {
        commit("DELETE_ORGANIZATION_BUSY", true);

        const { accessToken } = rootState.user.user.data;
        const config = {
            headers: { Authorization: `Token token=${accessToken}` }
        };

        return Axios.delete(`${API_HOST}/analysis/${projectId}/organizations/${organizationId}`, config)
            .then(function(response) {
                commit("DELETE_ORGANIZATION_SUCCESS", response.data);
            })
            .catch(function(error) {
                Vue.notify({
                    group: "store_notifications",
                    type: "error",
                    text: i18n.t("messages.request.error")
                });

                console.error(error);
                commit("DELETE_ORGANIZATION_FAIL", error);
            })
            .finally(function() {
                commit("DELETE_ORGANIZATION_BUSY", false);
            });
      }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
  };